// extracted by mini-css-extract-plugin
export default {"skillsBlock":"Skills_skillsBlock__uZg1b","skillsContainer":"Skills_skillsContainer__m1Rxc"};